import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {IMyprofile, IProfile, IProfileState} from "./types";
import {fetchMyProfiles, fetchProfileInfoMenu} from "./asyncActions";

const initialState: IProfileState = {
    profile: [],
    myProfiles: [],
    isLoading: false,
    deleteProfile: {},
    newProfile: {},
}

const GetProfileInfoMenu = createSlice({
  name: "getProfileInfo",
  initialState,
  reducers: {
      setDeleteProfile(state, action: PayloadAction<IMyprofile>) {
          state.deleteProfile = {
              ...state.deleteProfile,
              ...action.payload,
          };
      },
      editProfile(state, action: PayloadAction<object>) {
          state.newProfile = action.payload;
      },
  },
  extraReducers: (builder) => {
      builder.addCase(fetchProfileInfoMenu.pending, (state) => {
          state.isLoading = true;
      })
      builder.addCase(
          fetchProfileInfoMenu.fulfilled,
          (state, action: PayloadAction<any>) => {
              const data = action.payload;
              state.profile = Array.isArray(data) ? data : [data];
              state.isLoading = false;
          }
      );
      builder.addCase(fetchMyProfiles.pending, (state) => {
          state.isLoading = true;
      })
      builder.addCase(
          fetchMyProfiles.fulfilled,
          (state, action: PayloadAction<any[]>) => {
              state.myProfiles = action.payload.map((profile) => ({
                  ...profile,
                  type: profile.is_adult ? "adult" : "kid",
                  birthday: profile.birth_date || null,
                  deleted: profile.deleted_at ? 1 : 0,
                  is_self: 0,
                  phone_1c_format_not_needed: null,
                  unique: null,
              })) as IMyprofile[];
              state.isLoading = false;
          }
      );
  },
});

export default GetProfileInfoMenu.reducer;
export const { setDeleteProfile,editProfile } = GetProfileInfoMenu.actions;

